export const detectBreakpoints = () => {
  const isMobileView = () => window.matchMedia("(max-width: 992px)").matches;

  return {
    isMobileView,
  };
};
